import React from 'react';
import { useTranslation } from 'react-i18next';

import { FormField, IFormInput } from 'common/components/form/Wrapper';

type IEmailFiled = Omit<IFormInput, 'type' | 'icon' | 'max' | 'min' | 'step' | 'placeholder'>;

export const EmailField = ({ name, ...rest }: IEmailFiled) => {
  const { t } = useTranslation();

  return <FormField {...rest} name={name} type="email" placeholder={rest.placeholder} />;
};
